// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3M1qx","bigColWidth":"Table_bigColWidth__grPJO","biggerColWidth":"Table_biggerColWidth__2VAh8","row":"Table_row__WZbZb","col":"Table_col__1MpmH"};